import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Bell, CheckCheck } from "lucide-react";
import { api, fmtDate, fmtMoney } from "@/lib/api";
import { useAuth } from "@/hooks/useAuth";
import { Button } from "@/components/ui/button";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";

const POLL = 30_000;

export const NotificationsBell = () => {
  const { user } = useAuth();
  const nav = useNavigate();
  const [items, setItems] = useState([]);
  const allowed = user?.role === "admin" || user?.role === "gestionnaire";
  useEffect(() => {
    if (!allowed) return;
    const load = () => api.get("/notifications").then((r) => setItems(r.data)).catch(() => {});
    load();
    const t = setInterval(load, POLL);
    return () => clearInterval(t);
  }, [allowed]);
  if (!allowed) return null;
  const unread = items.filter((n) => !n.read);
  const markAll = async () => { await api.post("/notifications/read", []); setItems(items.map((n) => ({ ...n, read: true }))); };
  const open = async (n) => { await api.post("/notifications/read", [n.id]); setItems(items.map((x) => (x.id === n.id ? { ...x, read: true } : x))); nav(`/ventes?open=${n.sale_id}`); };
  return (
    <Popover>
      <PopoverTrigger asChild>
        <button type="button" className="relative rounded-md p-2 text-slate-600 hover:bg-[#ccfbf1] hover:text-[#0f766e]" title="Notifications" data-testid="notifications-bell">
          <Bell size={18} className={unread.length ? "animate-pulse text-amber-600" : ""} />
          {unread.length > 0 && <span className="absolute -right-0.5 -top-0.5 flex h-5 min-w-5 items-center justify-center rounded-full bg-red-600 px-1 text-[10px] font-bold text-white" data-testid="notifications-count">{unread.length}</span>}
        </button>
      </PopoverTrigger>
      <PopoverContent align="end" className="w-96 p-0" data-testid="notifications-panel">
        <div className="flex items-center justify-between border-b px-3 py-2"><span className="font-display font-semibold">Notifications</span>{unread.length > 0 && <Button size="sm" variant="ghost" className="h-7 text-xs" onClick={markAll} data-testid="notifications-read-all"><CheckCheck size={14} /> Tout marquer lu</Button>}</div>
        <div className="max-h-96 overflow-y-auto">
          {items.length === 0 && <p className="p-4 text-center text-sm text-muted-foreground">Aucune notification</p>}
          {items.map((n) => (
            <button key={n.id} type="button" onClick={() => open(n)} className={`block w-full border-b px-3 py-2 text-left text-sm hover:bg-muted/60 ${n.read ? "opacity-60" : "bg-amber-50"}`} data-testid={`notification-${n.id}`}>
              <p className="font-semibold">Vente <span className="font-mono">{n.number}</span> modifiée par {n.by}</p>
              <p className="text-xs text-muted-foreground">{n.warehouse_name} · {fmtDate(n.created_at)} · {fmtMoney(n.old_total)} → <b>{fmtMoney(n.new_total)}</b></p>
            </button>
          ))}
        </div>
      </PopoverContent>
    </Popover>
  );
};
